<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <button nz-button (click)="createMessage('success')" class="mr-3 mb-3">Success</button>
  <button nz-button (click)="createMessage('info')" class="mr-3 mb-3">Info</button>
  <button nz-button (click)="createMessage('error')" class="mr-3 mb-3">Error</button>
  <button nz-button (click)="createMessage('warning')" class="mr-3 mb-3">Warning</button>
</div>